<template>
  <div class='menu-wrapper'>
    <!-- <template v-for="item in allRoutes">
      <router-link v-if="!item.hidden && !item.children" :to="item.path" :key="item.path">
        <el-menu-item :index="item.path" class='submenu-title-noDropdown'>
          <i v-if="item.meta && item.meta.icon" :class="item.meta.icon"></i>
          <span slot="title" v-if="item.meta && item.meta.title">{{item.meta.title}}</span>
        </el-menu-item>
      </router-link>
      <el-submenu :index="item.name" v-if="!item.hidden && item.children && item.children.length > 0" :key="item.name">
        <template slot="title">
          <i v-if="item.meta&&item.meta.icon" :class="item.meta.icon"></i>
          <span v-if="item.meta && item.meta.title && !sliderBarState">{{item.meta.title}}</span>
        </template>
        <template v-for="child in item.children">
          <router-link :to="item.path+'/'+child.path" :key="child.name">
            <el-menu-item v-if="!child.hidden" :index="item.path+'/'+child.path">
              <i v-if="child.meta&&child.meta.icon" :class="child.meta.icon"></i>
              <span v-if="child.meta&&child.meta.title">{{child.meta.title}}</span>
            </el-menu-item>
          </router-link>
        </template>
      </el-submenu>
    </template> -->
     <template v-for="item in allRoutes" v-if="!item.hidden">
        <router-link v-if="hasOneShowingChildren(item.children) && !item.children[0].children && !item.alwaysShow" :to="item.path+'/'+item.children[0].path" :key="item.children[0].name">
          <el-menu-item :index="item.path+'/'+item.children[0].path">
            <i v-if="item.children[0].meta&&item.children[0].meta.icon" :class="item.children[0].meta.icon"></i>
            <span slot="title" v-if="item.children[0].meta&&item.children[0].meta.title">{{item.children[0].meta.title}}</span>
          </el-menu-item>
        </router-link>

        <el-submenu v-else :index="item.name||item.path" :key="item.name">
          <template slot="title">
            <i v-if="item.meta&&item.meta.icon" :class="item.meta.icon"></i>
            <span v-if="item.meta && item.meta.title && !sliderBarState">{{item.meta.title}}</span>
          </template>

          <template v-for="child in item.children" v-if="!child.hidden">
            <sidebar-item :is-nest="true" class="nest-menu" v-if="child.children&&child.children.length>0" :routes="[child]" :key="child.path"></sidebar-item>

            <router-link v-else :to="item.path+'/'+child.path" :key="child.name">
              <el-menu-item :index="item.path+'/'+child.path">
                <i v-if="child.meta&&child.meta.icon" :class="child.meta.icon"></i>
                <span v-if="child.meta&&child.meta.title">{{child.meta.title}}</span>
              </el-menu-item>
            </router-link>
          </template>
        </el-submenu>

      </template>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: 'SidebarItem',
  props: {
    allRoutes: {
      type: Array,
      default () {
        return ['获取路由失败']
      }
    }
  },
  computed: {
    ...mapGetters([
      'sliderBarState'
    ])
  },
  methods: {
    hasOneShowingChildren (children) {
      console.log(children)
      const showingChildren = children.filter(item => {
        return !item.hidden
      })
      if (showingChildren.length === 1) {
        return true
      }
      return false
    }
  }
}
</script>
<style scope lang="scss">
  .menu-wrapper {
    i {
      margin-right: 6px;
    }
    .el-menu-item *, .el-submenu__title * {
      // font-weight: bold;
      font-size: 14px;
    }
    .router-link-active  {
      background-color: #000;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/firmiana/layout/SidebarItem.vue